<template>
  <WdsButtonGhost :href="path" :title="column.job.name" class="job-po-number-column">
    <WdsText :text="column.job.name" :sub-text="column.purchaseOrderNumber ?? ''" />
  </WdsButtonGhost>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsButtonGhost, WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

const JobAndPoNumberColumn = graphql(`
  fragment JobAndPoNumberColumn on Hire {
    id
    purchaseOrderNumber
    job {
      id
      number
      name
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof JobAndPoNumberColumn> }>()
const column = computed(() => useFragment(JobAndPoNumberColumn, props.row))
const path = computed(() => laravelNamedRoute(namedRoutes.jobs.show, { job: column.value.job.id }))
</script>

<style lang="scss">
.job-po-number-column {
  .wds-text-primary {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 300px;
  }
}
</style>
